import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import { updateVehicleType } from '../services'
import { handleError } from '../../../helpers'

export default function EditVehicleTypeModal({ visible, onClose, vehicleType, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			name: vehicleType.name,
            load_capacity: vehicleType.load_capacity,
            unload_time: vehicleType.unload_time
		}
	})

	const onSubmit = values => {
		setLoading(true)
		updateVehicleType(vehicleType.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Tipo de Vehículo</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<Form.Group className='form-group'>
							<Form.Label>Código <span className='text-danger'>*</span></Form.Label>
							<Form.Control  value={vehicleType.sku} disabled />
						</Form.Group>
						<Form.Group className='form-group'>
							<Form.Label>Nombre del Tipo de Vehículo <span className='text-primary'>*</span></Form.Label>
							<Form.Control
								{...register('name', { required:true })}
								placeholder='Escriba aquí...'
							/>
							{ errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Row>
							<Form.Group className='form-group' as={Col}>
								<Form.Label>Capacidad de Carga <span className='text-danger'>*</span></Form.Label>
								<Form.Control 
									{...register('load_capacity', { required:true })}
									placeholder='Escriba aquí...'
									type="number"
								/>
								{ errors.load_capacity && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
							</Form.Group>
							<Form.Group className='form-group' as={Col}>
								<Form.Label>Tiempo de Descarga <span className='text-danger'>*</span></Form.Label>
								<Form.Control 
									{...register('unload_time', { required:true })}
									placeholder='Escriba aquí...'
									type="number"
									suffix=" minutos"
								/>
								{ errors.unload_time && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
							</Form.Group>
						</Row>
						<Button color="primary" type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
							Actualizar Tipo de Vehículo
						</Button>						
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}